// Registers the AnimalMela service worker for PWA install / offline shell.
// Skipped inside the native Capacitor shell (which loads via file:// and cannot
// use service workers) and when the browser has no SW support.

export function registerServiceWorker() {
  try {
    if (typeof window === "undefined") return;
    if (window?.Capacitor?.isNativePlatform?.()) return;
    if (!("serviceWorker" in navigator)) return;

    // Register on load so it never competes with app startup.
    window.addEventListener("load", () => {
      navigator.serviceWorker
        .register("/service-worker.js", { scope: "/" })
        .catch((err) => console.debug("SW register failed", err));
    });
  } catch (e) {
    console.debug("SW register error", e);
  }
}
